import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    description: 'Title for the Refund Assist section in FTU wizard',
    defaultMessage: 'Enable Refund Assist',
    id: '1Lehmv',
  },
  sectionDescription: {
    description: 'Description for the Refund Assist section in FTU wizard',
    defaultMessage:
      'With Refund Assist, ShipStation identifies which of your unused USPS labels are eligible for a refund and submits a refund request on your behalf.',
    id: 'aQMYTX',
  },
  toggleLabel: {
    description: 'Label for the Refund Assist toggle in FTU wizard',
    defaultMessage: 'Refund Assist',
    id: 'SDFPl9',
  },
  toggleCaption: {
    description: 'Message to display below the Label for the Refund Assist toggle in FTU wizard',
    defaultMessage: 'ShipStation can request refunds for unused USPS labels on your behalf.',
    id: '5nDeQ8',
  },
  disclaimerParagraph1: {
    description: 'First paragraph of Refund Assist disclaimer about refund percentage',
    defaultMessage:
      "ShipStation identifies unused USPS® shipping labels and submits refund requests on your behalf, so you don't lose money on unused labels. You'll receive 70% of the USPS-approved refund amount as account credit.",
    id: 'pFwbVl',
  },
  disclaimerParagraph2: {
    description: 'Second paragraph of Refund Assist disclaimer about review period',
    defaultMessage:
      'The review includes USPS labels that have not entered the mail stream within 21 days of the label print date. You can view eligible labels on the Shipments > Refund Assist page at any time. Once a refund request has been scheduled for a label, you have about 7 days to exclude any labels you do not want refunded through Refund Assist.',
    id: 'YzMYEe',
  },
  disclaimerParagraph3: {
    description: 'Third paragraph of Refund Assist disclaimer about USPS review timeline',
    defaultMessage:
      "ShipStation will then submit the refund request for the eligible labels to USPS on your behalf. USPS reviews the request within 1-4 weeks. You'll then receive a credit to your account balance for 70% of the USPS-approved refund amount.",
    id: 'qqk8PF',
  },
  disclaimerParagraph4: {
    description: 'Fourth paragraph of Refund Assist disclaimer about USPS review timeline',
    defaultMessage:
      'To view the credited amount for any specific label, go to the Shipments > Refund Assist page and open the Shipment Details.',
    id: 'qVlhOs',
  },
  readMore: {
    description: 'Button text to expand disclaimer content',
    defaultMessage: 'Read more',
    id: 'NFnj44',
  },
  readLess: {
    description: 'Button text to collapse disclaimer content',
    defaultMessage: 'Read less',
    id: '2yoVem',
  },
  termsAndConditions: {
    description: 'External link to the terms and conditions page',
    defaultMessage: 'Terms and conditions',
    id: 'XVKVMs',
  },
});
